import {
  getRawGrpcResponseErrorStatus,
  useGrpcRequest,
} from '@aboutyou/data-fetcher';
import {SessionService_ResumeLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/session/service.grpc.lazy';
import {ResumeResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/session/service.types';
import {Log} from '@aboutyou/mlm';
import {createDataStore} from '../createDataStore';
import {useCustomerSession} from '../userStore/useSession';
import {useUserLoginType} from '../userStore/user.selector';

const useResumeRequest = () => {
  const customerSession = useCustomerSession();
  const authToken = customerSession?.authToken;
  const authMedium = useUserLoginType() || 'NA'; // Default to 'NA' if no loginType is not available, can happen in case user rejects cookie consent.

  return useGrpcRequest(
    SessionService_ResumeLazy,
    {customerSession: {authToken: authToken!}},
    {
      disabled: !authToken,
      onSuccess: data => {
        Log.compare({
          actionName: 'SessionValidation',
          success: true,
          attributes: {
            authMedium,
            coSessionValid: data.coSessionValid,
          },
        });
      },
      onError: error => {
        const {errorReason, errorCode} = getErrorCodeAndReason(error as Error);
        Log.compare({
          actionName: 'SessionValidation',
          success: false,
          attributes: {
            authMedium,
            errorReason,
            errorCode,
            coSessionValid: false,
          },
        });

        if (
          errorCode === undefined ||
          ![2, 16, 9000, 9001].includes(errorCode)
        ) {
          Log.unSampledLog('SessionValidationError', {
            error: error as Error,
            errorReason,
          });
        }
      },
    },
  );
};

export const getErrorCodeAndReason = (
  e: Error,
): {errorReason: string; errorCode?: number} => {
  const errorCode = getRawGrpcResponseErrorStatus(e);

  switch (errorCode) {
    case 16:
      return {errorReason: 'Unauthenticated', errorCode};
    case 9000:
      return {errorReason: 'InvalidSession', errorCode};
    case 9001:
      return {errorReason: 'LoginRequired', errorCode};
    default:
      return {errorReason: e.message ?? 'request error', errorCode};
  }
};

const {Provider, useData: useResumeRequestResponse} = createDataStore<
  ResumeResponse | undefined
>({
  defaultValue: undefined,
  useQueryHook: useResumeRequest,
});

export {Provider as CustomerSessionValidProvider, useResumeRequestResponse};
